'use strict';
const angular = require('angular');
import * as ControlProperties from './Controls/Controls'

/*@ngInject*/
export function localStorageService() {

    let store: any = {
        components: {
            selected: null,
            items: [
                {
                    type: 'Label',
                    label: 'label',
                    id: 1,
                    cssclass: 'icon fa fa-font',
                    properties: ControlProperties.LabelProperties
                },
               
                {
                    type: 'Display field',
                    label: 'display.field',
                    id: 1,
                    cssclass: 'icon fa fa-function',
                    properties: ControlProperties.DisplayFieldPropertise
                },
                {
                    type: 'Hyperlink',
                    label: 'hyperlink',
                    id: 1,
                    cssclass: 'icon fa fa-link',
                    properties: ControlProperties.HyperlinkProperties
                },
                {
                    type: 'Textbox',
                    label: 'textbox',
                    id: 1,
                    cssclass: 'icon fa fa-square-o',
                    properties: ControlProperties.TextboxProperties
                }, {
                    type: 'Text-Area',
                    label: 'textarea',
                    id: 1,
                    cssclass: 'icon fa fa-file-code-o',
                    properties: ControlProperties.TextareaProperties
                }, {
                    type: 'Rich-Text-Box',
                    label: 'rich.text.box',
                    id: 1,
                    cssclass: 'icon fa fa-file-code-o',
                    properties: ControlProperties.RichTextAreaProperties
                }, {
                    type: 'Dropdown',
                    label: 'dropdown',
                    id: 1,
                    cssclass: 'icon fa fa-caret-square-o-down',
                    data: [],
                    selectedItem: '',
                    properties: ControlProperties.DropdownProperties
                }, {
                    type: 'MultiDropdown',
                    label: 'multidropdown',
                    id: 1,
                    cssclass: 'icon fa fa-caret-square-o-down',
                    data: [],
                    selectedItem: '',
                    properties: ControlProperties.MultiDropdownProperties
                },{
                    type: 'Checkbox',
                    label: 'checkbox',
                    id: 1,
                    cssclass: 'icon fa fa-check-square-o',
                    properties: ControlProperties.CheckboxProperties
                }, {
                    type: 'Radio',
                    label: 'radio',
                    id: 1,
                    cssclass: 'icon fa fa-dot-circle-o',
                    properties: ControlProperties.RadioProperties
                },
                {
                    type: 'Datepicker',
                    label: 'date.picker',
                    id: 1,
                    cssclass: 'icon fa fa-calendar',
                    properties: ControlProperties.DatepickerProperties
                },
                {
                    type: 'Timepicker',
                    label: 'time.picker',
                    id: 1,
                    cssclass: 'icon fa fa-clock-o',
                    properties: ControlProperties.TimepickerProperties
                },
                {
                    type: 'Map',
                    label: 'map',
                    id: 1,
                    cssclass: 'icon fa fa-map-marker',
                    properties: ControlProperties.MapProperties
                },
                {
                    type: 'Image',
                    label: 'image',
                    id: 1,
                    cssclass: 'icon fa fa-picture-o',
                    properties: ControlProperties.ImageProperties
                }, {
                    type: 'Signature',
                    label: 'signature',
                    id: 1,
                    cssclass: 'icon fa fa-pencil-square-o',
                    properties: ControlProperties.SignatureProperties
                },
                {
                    type: 'Attachment',
                    label: 'attachment',
                    id: 1,
                    cssclass: 'icon fa fa-paperclip',
                    properties: ControlProperties.AttachmentProperties
                },
                {
                    type: 'Button',
                    label: 'button',
                    id: 1,
                    cssclass: 'icon fa fa-plus',
                    properties: ControlProperties.ButtonProperties
                },
                {
                    type: 'SiteLocationButton',
                    label: 'Site Location',
                    id: 1,
                    cssclass: 'icon fa fa-thumb-tack',
                    properties: ControlProperties.SiteLocationButtonProperties
                },
                {
                    type: 'ToggleButton',
                    label: 'togglebutton',
                    id: 1,
                    cssclass: 'icon fa fa-toggle-on',
                    properties: ControlProperties.ToggleButtonProperties
                },
                {
                    type: 'Line',
                    label: 'line',
                    id: 1,
                    cssclass: 'separator',
                    properties: ControlProperties.LineProperties
                },
                {
                    type: 'Rating',
                    label: 'rating',
                    id: 1,
                    cssclass: 'icon fa fa-square-o',
                    properties: ControlProperties.RatingProperties
                },
                {
                    type: 'Layout',
                    label: 'layout',
                    id: 1,
                    cssclass: 'icon fa fa-columns',
                    data: [
                        { elems: [[]] }, { elems: [[]] }
                    ],
                    ids: [],
                    selectedRows: [],
                    width: {},
                    reset: false,
                    columnMap: {
                        1: 12,
                        2: 6,
                        3: 4,
                        4: 3,
                        5: 5,
                        6: 2,
                        7: 7,
                        8: 8,
                        9: 9,
                        10: 10,
                        11: 11,
                        12: 1
                    },
                    properties: ControlProperties.LayoutProperties
                },
                {
                    type: 'Section',
                    label: 'section',
                    id: 1,
                    cssclass: 'icon fa fa-columns',
                    data: 
                        { elems: [[]] }
                    ,
                    ids: [],
                    reset: false,
                    
                    properties: ControlProperties.SectionProperties
                },
                {
                    type: 'Table',
                    label: 'table',
                    id: 1,
                    cssclass: 'icon fa fa-table',
                    data: [
                        [{ elems: [[]] }, { elems: [[]] }, { elems: [[]] }],
                        [{ elems: [[]] }, { elems: [[]] }, { elems: [[]] }],
                        [{ elems: [[]] }, { elems: [[]] }, { elems: [[]] }]
                    ],
                    ids: [],
                    selectedRows: [],
                    width: {},
                    reset: false,
                    columnMap: {
                        1: 12,
                        2: 6,
                        3: 4,
                        4: 3,
                        5: 5,
                        6: 2,
                        7: 7,
                        8: 8,
                        9: 9,
                        10: 10,
                        11: 11,
                        12: 1
                    },
                    properties: ControlProperties.TableProperties
                },
                {
                    type: 'RepeatingTable',
                    label: 'repeating.table',
                    id: 1,
                    cssclass: 'icon fa fa-table',
                    data: [
                        [{ elems: [[]] }, { elems: [[]] }, { elems: [[]] }],
                    ],
                    header_data: [
                        [{ elems: [[]] }, { elems: [[]] }, { elems: [[]] }],
                    ],
                    footer_data: [
                        [{ elems: [[]] }, { elems: [[]] }, { elems: [[]] }],
                    ],
                    ids: [],
                    selectedRows: [],
                    width: {},
                    reset: false,
                    columnMap: {
                        1: 12,
                        2: 6,
                        3: 4,
                        4: 3,
                        5: 5,
                        6: 2,
                        7: 7,
                        8: 8,
                        9: 9,
                        10: 10,
                        11: 11,
                        12: 1
                    },
                    properties: ControlProperties.RepeatingTableProperties
                },
                {
                    type: 'InlineAssocFiles',
                    label: 'Associate Files',
                    id: 1,
                    cssclass: 'fa fa-file-o',
                    data: [
                        [{ elems: [[]] }, { elems: [[]] }, { elems: [[]] }],
                    ],
                    header_data: [
                        [{ elems: [[]] }, { elems: [[]] }, { elems: [[]] }],
                    ],
                    footer_data: [
                        [{ elems: [[]] }, { elems: [[]] }, { elems: [[]] }],
                    ],
                    ids: [],
                    selectedRows: [],
                    width: {},
                    reset: false,
                    columnMap: {
                        1: 12,
                        2: 6,
                        3: 4,
                        4: 3,
                        5: 5,
                        6: 2,
                        7: 7,
                        8: 8,
                        9: 9,
                        10: 10,
                        11: 11,
                        12: 1
                    },
                    properties: ControlProperties.InlineAssocFiles
                },
                {
                    type: 'InlineAssocApps',
                    label: 'Associate Apps',
                    id: 1,
                    cssclass: 'fa fa-file-text-o',
                    data: [
                        [{ elems: [[]] }, { elems: [[]] }, { elems: [[]] }],
                    ],
                    header_data: [
                        [{ elems: [[]] }, { elems: [[]] }, { elems: [[]] }],
                    ],
                    footer_data: [
                        [{ elems: [[]] }, { elems: [[]] }, { elems: [[]] }],
                    ],
                    ids: [],
                    selectedRows: [],
                    width: {},
                    reset: false,
                    columnMap: {
                        1: 12,
                        2: 6,
                        3: 4,
                        4: 3,
                        5: 5,
                        6: 2,
                        7: 7,
                        8: 8,
                        9: 9,
                        10: 10,
                        11: 11,
                        12: 1
                    },
                    properties: ControlProperties.InlineAssocApps
                },
                {
                    type: 'ViewAssociations',
                    label: 'view.associations',
                    id: 1,
                    cssclass: 'fa fa-file-text-o',
                    data: [
                        [{ elems: [[]] }, { elems: [[]] }, { elems: [[]] }],
                    ],
                    header_data: [
                        [{ elems: [[]] }, { elems: [[]] }, { elems: [[]] }],
                    ],
                    footer_data: [
                        [{ elems: [[]] }, { elems: [[]] }, { elems: [[]] }],
                    ],
                    ids: [],
                    selectedRows: [],
                    width: {},
                    reset: false,
                    columnMap: {
                        1: 12,
                        2: 6,
                        3: 4,
                        4: 3,
                        5: 5,
                        6: 2,
                        7: 7,
                        8: 8,
                        9: 9,
                        10: 10,
                        11: 11,
                        12: 1
                    },
                    properties: ControlProperties.ViewAssociations
                }
            ]
        },
        views: {
            'ORI_VIEW': {
                editing: false,
                controls: {
                    'A': []
                },
                viewName: 'ORI_VIEW'
            }
        },
        selectedView: {
            view: {}
        },
        Languages: {

        },
        templates: {
            items: [
                {
                    type: 'ReviewTemplate',
                    label: 'reviewtemplatelabel',
                    id: 1,
                    cssclass: 'icon fa fa-font',
                    name:'reviewcomponent'
                    
                },
            ]
        },
        numberFormatEnabled: false
    };

    function getData(key: string) {
        return store[key];
    };

    function setData(key: string, value: any) {
        store[key] = value;
    };

    return {
        set: setData,
        get: getData
    };
}

export default angular.module('nodeApp.localStorage', [])
    .service('localStorage', localStorageService)
    .name;



// WEBPACK FOOTER //
// ./client/app/localStorage/localStorage.service.ts